import { render, staticRenderFns } from "./CategoryForm.vue?vue&type=template&id=7807a7e6&scoped=true&lang=html&"
import script from "./CategoryForm.vue?vue&type=script&lang=js&"
export * from "./CategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807a7e6",
  null
  
)

export default component.exports